/* ==========================================================================
   Bazan — AirReviews tweaks. Rút gọn text của filter badge:
   "Showing N-star reviews only" -> "N stars" để hiển thị dạng chip.
   App re-render badge khi lọc/sort nên dùng MutationObserver.
   ========================================================================== */
(function () {
  'use strict';

  function shorten() {
    document.querySelectorAll('.AirReviews-Blocks__RatingFilterBadge__Text').forEach(function (t) {
      // Sửa .data của chính text node (KHÔNG dùng textContent) để giữ nguyên node
      // -> app (React) vẫn cập nhật được số sao khi đổi filter.
      var node = t.firstChild;
      if (node && node.nodeType === 3 && /Showing/i.test(node.data)) {
        var m = node.data.match(/(\d+)/);
        if (m) node.data = m[1] + ' ★'; // "5 ★"
      }
    });
  }

  // Đổi text badge "Verified" -> "Verified Purchase" (sửa .data để giữ node cho app).
  function relabelVerified() {
    document.querySelectorAll('.AirReview-BadgeIcon__Text').forEach(function (t) {
      var node = t.firstChild;
      if (node && node.nodeType === 3 && node.data.trim() === 'Verified') {
        node.data = 'Verified Purchase';
      }
    });
  }

  // Đổi tiêu đề "Reviews" -> "Customer Reviews".
  function relabelTitle() {
    document.querySelectorAll('.AirReviews-Blocks--Title').forEach(function (t) {
      var node = t.firstChild;
      if (node && node.nodeType === 3 && node.data.trim() === 'Reviews') {
        node.data = 'Customer Reviews';
      }
    });
  }

  // Đổi text popup "Thank you" cho thân thiện (sửa .data để giữ node cho app).
  function relabelThankYou() {
    document.querySelectorAll('.AirReviews-SubmitResult__Content').forEach(function (t) {
      var node = t.firstChild;
      if (node && node.nodeType === 3 && /Thank you for your information/i.test(node.data)) {
        node.data = 'Thank you for your review!';
      }
    });
  }


  // ---- Loading overlay khi lọc review (giống gossby): MIN 1s, MAX = load thật ----
  var RL = { loaded: false, minElapsed: false, minTimer: null, maxTimer: null };
  function rlMaybeHide() {
    if (RL.loaded && RL.minElapsed) {
      var ov = document.querySelector('.bz-review-loading');
      if (ov) ov.remove();
      clearTimeout(RL.maxTimer);
    }
  }
  function showReviewLoading() {
    // Chèn vào .AirReviews-Blocks__List (node ổn định, đã position:relative trong
    // bz-base.css). KHÔNG chèn vào .AirReviews-Blocks__ListReview: lúc load app đổi
    // class chính node đó thành ...__ListReview--Loader (cùng 1 node) -> overlay bị
    // nhét vào hộp loader 32px, lệch vị trí và thành 2 spinner.
    var wrap = document.querySelector('.AirReviews-Blocks__List');
    if (!wrap || wrap.querySelector('.bz-review-loading')) return;
    var ov = document.createElement('div');
    ov.className = 'bz-review-loading';
    ov.innerHTML = '<span class="bz-review-loading__spinner"></span>';
    wrap.appendChild(ov);
    RL.loaded = false;
    RL.minElapsed = false;
    clearTimeout(RL.minTimer);
    clearTimeout(RL.maxTimer);
    RL.minTimer = setTimeout(function () { RL.minElapsed = true; rlMaybeHide(); }, 1000); // MIN 1s
    RL.maxTimer = setTimeout(function () { var o = document.querySelector('.bz-review-loading'); if (o) o.remove(); }, 8000); // an toàn: force hide
  }
  // "Load xong" = app đã trả list về (không còn node ...__ListReview--Loader).
  // Không đếm mutation added/removed như trước: app xoá content ngay lúc BẮT ĐẦU
  // load nên cách cũ báo xong quá sớm -> overlay tắt khi chưa load thật.
  var bzScrollAfterPage = false;
  function watchReviewList() {
    var list = document.querySelector('.AirReviews-Blocks__List');
    if (!list || list.__bzRLwatched) return;
    list.__bzRLwatched = true;
    new MutationObserver(function () {
      var loaderGone = !document.querySelector('.AirReviews-Blocks__ListReview--Loader');
      // Nhịp 2 của scroll phân trang: trang mới đã render (loader biến mất +
      // đã có review card) -> cuộn lại về đầu section cho chuẩn vị trí.
      if (loaderGone && bzScrollAfterPage && document.querySelector('.AirReviews-Blocks__ListReview .AirReviews-Blocks__ReviewDetails')) {
        bzScrollAfterPage = false;
        var anchor = bzReviewsAnchor();
        if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (!document.querySelector('.bz-review-loading')) return;
      if (loaderGone) {
        RL.loaded = true;
        rlMaybeHide();
      }
    }).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // ---- Filter bottom-sheet: nút "Filters" + sheet chips rating, wire vào filter
  // sẵn có của AirReviews (click hàng breakdown để lọc sao, Clear để về All). Dùng
  // chung filter với pill-grid nên 2 cái luôn đồng bộ. ----
  function bzFilterApply(v) {
    if (v === 'all') {
      var c = document.querySelector('.AirReviews-Blocks__RatingFilterBadge__Clear');
      if (c) c.click();
    } else {
      var row = [].slice.call(document.querySelectorAll('.AirReviews-Blocks--List .AirReviews-Blocks--ListItem--Clickable'))
        .filter(function (r) { return new RegExp('^' + v + ' star', 'i').test(r.getAttribute('aria-label') || ''); })[0];
      if (row && !row.classList.contains('AirReviews-Blocks--ListItem--Active')) row.click();
    }
  }
  function bzFilterCurrent() {
    var a = document.querySelector('.AirReviews-Blocks--List .AirReviews-Blocks--ListItem--Clickable.AirReviews-Blocks--ListItem--Active');
    if (!a) return 'all';
    var m = (a.getAttribute('aria-label') || '').match(/^(\d)\s*star/i);
    return m ? m[1] : 'all';
  }
  function openFilterSheet() {
    if (document.querySelector('.bz-filters-backdrop')) return;
    var sel = bzFilterCurrent(), selected = sel;
    var bd = document.createElement('div');
    bd.className = 'bz-filters-backdrop';
    // Chỉ cho phép All / 5★ / 4★ — bỏ 1,2,3 star vì volume thấp / policy.
    var chips = ['all', '5', '4'].map(function (v) {
      return '<button type="button" class="bz-filters-chip' + (v === sel ? ' bz-filters-chip--active' : '') + '" data-v="' + v + '">' + (v === 'all' ? 'All' : v + ' ★') + '</button>';
    }).join('');
    bd.innerHTML = '<div class="bz-filters-sheet" role="dialog" aria-modal="true" aria-label="Filters">'
      + '<div class="bz-filters-handle"></div>'
      + '<h3 class="bz-filters-title">Filters</h3>'
      + '<p class="bz-filters-sub">Narrow down the reviews</p>'
      + '<p class="bz-filters-label">Rating</p>'
      + '<div class="bz-filters-chips">' + chips + '</div>'
      + '<div class="bz-filters-actions"><button type="button" class="bz-filters-reset">Reset</button><button type="button" class="bz-filters-apply">Apply</button></div>'
      + '</div>';
    document.body.appendChild(bd);
    function setSel(v) { selected = v; bd.querySelectorAll('.bz-filters-chip').forEach(function (c) { c.classList.toggle('bz-filters-chip--active', c.getAttribute('data-v') === v); }); }
    bd.addEventListener('click', function (e) {
      if (e.target === bd) { bd.remove(); return; } // click nền -> đóng
      var chip = e.target.closest && e.target.closest('.bz-filters-chip');
      if (chip) { setSel(chip.getAttribute('data-v')); return; }
      if (e.target.closest('.bz-filters-reset')) { setSel('all'); return; }
      if (e.target.closest('.bz-filters-apply')) {
        if (selected !== bzFilterCurrent()) showReviewLoading(); // đổi filter -> loading (min1s/max load)
        bzFilterApply(selected);
        bd.remove();
      }
    });
  }
  // Chèn nút "Filters" vào đầu toolbar sort (cạnh sort + per-page).
  function ensureFiltersButton() {
    var left = document.querySelector('.AirReviews-ListSort__Left');
    if (!left || left.querySelector('.bz-filters-btn')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bz-filters-btn';
    btn.innerHTML = '<span aria-hidden="true">☰</span> Filters';
    left.insertBefore(btn, left.firstChild);
  }

  // "% recommend": tính từ breakdown (số review 4-5 sao / tổng), chèn vào khối Rate.
  function ensureRecommend() {
    var rate = document.querySelector('.AirReviews-Blocks--Rate');
    if (!rate) return;
    var rows = [].slice.call(document.querySelectorAll('.AirReviews-Blocks--List .AirReviews-Blocks--ListItem--Clickable'));
    if (!rows.length) return;
    var total = 0, rec = 0;
    rows.forEach(function (li) {
      var sm = (li.getAttribute('aria-label') || '').match(/^(\d)/);
      var cnt = li.querySelector('.AirReviews-Blocks-Count');
      var star = sm ? +sm[1] : 0;
      var c = cnt ? parseInt((cnt.textContent || '').replace(/[^\d]/g, ''), 10) || 0 : 0;
      total += c;
      if (star >= 4) rec += c;
    });
    if (!total) return;
    var pct = Math.round(rec / total * 100);
    var el = rate.querySelector('.bz-recommend');
    if (!el) { el = document.createElement('div'); el.className = 'bz-recommend'; rate.appendChild(el); }
    var txt = pct + '% of reviewers recommend this product';
    if (el.textContent !== txt) el.textContent = txt;
  }

  // Chèn heading "Review this Product" phía trên bộ chọn sao (app chỉ có legend ẩn).
  function ensureReviewCta() {
    var submit = document.querySelector('.AirReviews-Blocks__SubmitReview');
    if (!submit || submit.querySelector('.bz-review-cta')) return;
    var h = document.createElement('div');
    h.className = 'bz-review-cta';
    h.textContent = 'Review this Product';
    submit.insertBefore(h, submit.firstChild);
  }

  // Ô vuông rate: tô vàng (bz-star-on) tới ô thứ n khi hover; MẶC ĐỊNH KHÔNG tô
  // — nền trắng viền mint (req), rời chuột trả về 0.
  function paintStars(n) {
    var labels = document.querySelectorAll('.AirReviews-Blocks__ActionRate .AirReviews-StarRadio__Label');
    for (var i = 0; i < labels.length; i++) labels[i].classList.toggle('bz-star-on', i < n);
  }

  // Đổi nhãn option sort "Review with media" -> "Media first": bản chất nó là
  // SORT (đưa review có ảnh lên đầu, app vẫn trả đủ review không ảnh) chứ không
  // phải filter — nhãn cũ gây hiểu lầm. Áp cho cả option trong dropdown lẫn
  // Value đang chọn; sửa .data để giữ node cho app (React).
  function relabelMediaSort() {
    document.querySelectorAll('.bz-sort-select .AirReviews-Select__Option, .bz-sort-select .AirReviews-Select__Value').forEach(function (t) {
      var node = t.firstChild;
      if (node && node.nodeType === 3 && /Review with media/i.test(node.data)) {
        node.data = 'Media first';
      }
    });
  }

  // Toolbar: tag select sort/per-page (để CSS order + style) + chèn label "Show".
  function ensureShowLabel() {
    var left = document.querySelector('.AirReviews-ListSort__Left');
    if (!left) return;
    var selects = left.querySelectorAll('.AirReviews-Select');
    if (selects.length < 2) return;
    var sortSel = selects[0], perPage = selects[selects.length - 1];
    sortSel.classList.add('bz-sort-select');
    perPage.classList.add('bz-perpage-select');
    var prev = perPage.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains('bz-show-label')) return;
    var lbl = document.createElement('span');
    lbl.className = 'bz-show-label';
    lbl.textContent = 'Show';
    left.insertBefore(lbl, perPage);
  }

  // "Mặc định show 3 review" (req): app không có per-page 3 (chỉ 10/20/50/100)
  // nên KHÔNG đổi per-page — để app load 10 như thường, chỉ ẨN từ review thứ 4
  // (class bz-hide) + chèn nút "Show all reviews". Bấm nút -> hiện đủ, trả lại
  // pagination/chip Show (CSS ẩn theo .bz-collapsed trên Blocks__List). App
  // re-render khi sort/filter -> observer gọi lại hàm này; cờ bzShowAll giữ
  // trạng thái đã mở rộng cho tới lần load trang sau.
  var bzShowAll = false;
  function ensureCollapsedReviews() {
    var list = document.querySelector('.AirReviews-Blocks__List');
    if (!list) return;
    var btn = list.querySelector('.bz-show-all');
    var cards = list.querySelectorAll('.AirReviews-Blocks__ListReview .AirReviews-Blocks__ReviewDetails');
    if (!cards.length) return; // đang loading (app xoá content) -> giữ nguyên trạng thái
    if (bzShowAll || cards.length <= 3) {
      list.classList.remove('bz-collapsed');
      for (var i = 0; i < cards.length; i++) cards[i].classList.remove('bz-hide');
      if (btn) btn.remove();
      return;
    }
    list.classList.add('bz-collapsed');
    for (var j = 0; j < cards.length; j++) cards[j].classList.toggle('bz-hide', j >= 3);
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bz-show-all';
      btn.textContent = 'Show all reviews';
      var listReview = list.querySelector('.AirReviews-Blocks__ListReview');
      if (listReview) listReview.insertAdjacentElement('afterend', btn);
      else list.appendChild(btn);
    }
  }

  // Desktop: app render sao ĐƠN nằm TRONG RateCount (mobile: hàng 5 sao là con
  // trực tiếp của Rate nên grid 2x2 Phase 3 mới ăn). Dựng lại hàng 5 sao
  // .bz-desktop-stars từ icon sao có sẵn của app, % fill tính từ aria-label
  // "3.3 out of 5 stars", chèn ngay sau RateCount (= con trực tiếp của Rate ->
  // rơi đúng ô col1/row2 như mobile). CSS ẩn sao đơn + Divider. Mobile không có
  // sao đơn trong RateCount -> dọn .bz-desktop-stars thừa (nếu vừa resize) rồi thôi.
  function ensureDesktopStars() {
    var rate = document.querySelector('.AirReviews-Blocks--Rate');
    if (!rate) return;
    var single = rate.querySelector('.AirReviews-Blocks--RateCount .AirReviews-StarRate');
    var built = rate.querySelector('.bz-desktop-stars');
    if (!single) { if (built) built.remove(); return; } // DOM mobile
    if (built) return;
    var m = (single.getAttribute('aria-label') || '').match(/([\d.]+)\s*out of/);
    var rating = m ? parseFloat(m[1]) : 0;
    var posSpan = single.querySelector('.AirReviews-StarRate--Positive .Avada_Star-Icon');
    var negSpan = single.querySelector('.AirReviews-StarRate--Negative .Avada_Star-Icon');
    if (!posSpan || !negSpan) return;
    var stars = document.createElement('div');
    stars.className = 'AirReviews-StarRate medium AirReviews-StarRate--Default bz-desktop-stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', single.getAttribute('aria-label') || '');
    for (var i = 0; i < 5; i++) {
      var pct = Math.max(0, Math.min(1, rating - i)) * 100;
      var w = document.createElement('div');
      w.className = 'AirReviews-StarRate__Wrapper';
      var pos = document.createElement('div');
      pos.className = 'AirReviews-StarRate--Icon AirReviews-StarRate__Icon--Positive';
      pos.style.width = pct + '%';
      pos.appendChild(posSpan.cloneNode(true));
      var neg = document.createElement('div');
      neg.className = 'AirReviews-StarRate--Icon AirReviews-StarRate__Icon--Negative';
      var negClone = negSpan.cloneNode(true);
      negClone.classList.add('Avada_Star-Icon--empty'); // desktop app không gắn sẵn --empty
      neg.appendChild(negClone);
      w.appendChild(pos);
      w.appendChild(neg);
      stars.appendChild(w);
    }
    rate.querySelector('.AirReviews-Blocks--RateCount').insertAdjacentElement('afterend', stars);
  }

  // Ngày review < 3 tháng -> hiển thị tương đối (a day ago / N days ago /
  // 1 month ago / 2 months ago); >= 3 tháng giữ nguyên MM/DD/YYYY. Sửa .data
  // của text node (giữ node cho React); text đã convert không còn match
  // pattern ngày nên không bị convert lặp khi observer chạy lại.
  function relativizeDates() {
    document.querySelectorAll('.AirReviews-Blocks__Date').forEach(function (d) {
      var node = d.firstChild;
      if (!node || node.nodeType !== 3) return;
      var m = node.data.match(/^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*$/);
      if (!m) return;
      var dt = new Date(+m[3], +m[1] - 1, +m[2]);
      // Lưu timestamp vào card để sort thứ cấp theo date (dùng bởi bzResortReviews).
      var card = d.closest && d.closest('.AirReviews-Blocks__ReviewDetails');
      if (card && !card.getAttribute('data-bz-ts')) {
        card.setAttribute('data-bz-ts', dt.getTime());
      }
      var now = new Date();
      var days = Math.floor((now - dt) / 86400000);
      if (days < 0) return; // ngày tương lai -> giữ nguyên
      var months = (now.getFullYear() - dt.getFullYear()) * 12 + (now.getMonth() - dt.getMonth());
      if (now.getDate() < dt.getDate()) months--;
      if (months >= 6) return; // >= 6 tháng -> giữ ngày gốc
      var txt;
      if (days === 0) txt = 'today';
      else if (days === 1) txt = 'a day ago';
      else if (months < 1) txt = days + ' days ago';
      else txt = months + (months === 1 ? ' month ago' : ' months ago');
      node.data = txt;
    });
  }

  // Sort thứ cấp: sau khi app đã sort theo rating (highest), reorder trong cùng
  // rating theo newest first. Đọc rating từ Positive star width (%), date từ
  // data-bz-ts (relativizeDates lưu). Guard bzSorting để tránh loop observer.
  var bzSorting = false;
  function bzResortReviews() {
    if (bzSorting) return;
    var list = document.querySelector('.AirReviews-Blocks__ListReview');
    if (!list) return;
    var cards = Array.prototype.slice.call(list.querySelectorAll(':scope > .AirReviews-Blocks__ReviewDetails'));
    if (cards.length < 2) return;

    function ratingOf(card) {
      var block = card.querySelector('.AirReviews-Blocks__ReviewDetails--StarsBlock, .AirReviews-StarRate');
      if (!block) return 0;
      var pos = block.querySelector('.AirReviews-StarRate--Positive');
      if (pos && pos.style && pos.style.width) {
        var pct = parseFloat(pos.style.width);
        if (!isNaN(pct)) return pct / 20; // 100% -> 5 sao
      }
      var aria = block.getAttribute('aria-label') || '';
      var mm = aria.match(/(\d+(?:\.\d+)?)/);
      return mm ? parseFloat(mm[1]) : 0;
    }
    function tsOf(card) {
      var v = parseInt(card.getAttribute('data-bz-ts') || '0', 10);
      return isNaN(v) ? 0 : v;
    }

    var indexed = cards.map(function (c, i) { return { c: c, r: ratingOf(c), t: tsOf(c), i: i }; });
    indexed.sort(function (a, b) {
      if (a.r !== b.r) return b.r - a.r;
      if (a.t !== b.t) return b.t - a.t;
      return a.i - b.i;
    });

    var same = indexed.every(function (x, idx) { return x.i === idx; });
    if (same) return;

    bzSorting = true;
    var frag = document.createDocumentFragment();
    indexed.forEach(function (x) { frag.appendChild(x.c); });
    list.appendChild(frag);
    setTimeout(function () { bzSorting = false; }, 40);
  }

  // Hard-code hiển thị số review + avg + breakdown (không đổi nội dung review khi filter).
  // Đọc từ window.bzArConfig do sections/apps.liquid emit. Sửa .data text node -> giữ node cho React.
  function overrideReviewCounts() {
    var cfg = window.bzArConfig;
    if (!cfg) return;
    // Skip override khi product thực tế 0 reviews trong app — tránh mismatch header
    // (fake 4.5/1234) vs list rỗng ("No reviews yet"). Detect qua text empty-state
    // hoặc số review card render trong list.
    var wrap = document.getElementById('AirReviews-BlockWrapper');
    if (wrap) {
      var realReviewCards = wrap.querySelectorAll('.AirReviews-Blocks__ReviewDetails').length;
      var txt = wrap.textContent || '';
      var hasEmptyState = /No reviews yet|No review yet|no reviews found/i.test(txt);
      if (realReviewCards === 0 && hasEmptyState) return;
    }
    var totalNumStr = cfg.total ? String(cfg.total).replace(/[^\d]/g, '') : '';
    // Total count "X reviews" — walk mọi text node, replace pattern số với totalNumStr
    if (cfg.total && totalNumStr) {
      var totalSelectors = '.AirReviews-Blocks--ReviewCount__Text, .AirReviews-Blocks--ReviewCount, .AirReviews-Blocks--RateCount';
      document.querySelectorAll(totalSelectors).forEach(function (el) {
        // Skip avg element (desktop có compound class heading8xl+RateCount) — số đó là avg 4.5, không phải total.
        if (el.classList.contains('AirReviews-Text--heading8xl')) return;
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = walker.nextNode())) {
          if (!/\d/.test(n.data)) continue;
          var replaced = n.data.replace(/[\d,]+/, totalNumStr);
          if (n.data !== replaced) n.data = replaced;
        }
      });
    }
    // Average rating (số lớn trong Rate) + visual star fill
    if (cfg.avg) {
      var avgEls = document.querySelectorAll('.AirReviews-Blocks--Rate .AirReviews-Text--heading8xl, .AirReviews-Text--heading8xl.AirReviews-Blocks--RateCount');
      if (window.bzArDebug) console.log('[bz avg]', 'want:', cfg.avg, 'targets:', avgEls.length);
      avgEls.forEach(function (t) {
        // Dùng TreeWalker để tìm text node đầu tiên có nội dung — element có thể có wrapper con.
        var walker = document.createTreeWalker(t, NodeFilter.SHOW_TEXT, null);
        var n, wrote = false;
        while ((n = walker.nextNode())) {
          if (!n.data.trim()) continue;
          if (n.data !== cfg.avg) { n.data = cfg.avg; wrote = true; }
          break;
        }
        // Dedicated observer trên element — re-enforce nếu React re-render/thay text.
        if (!t.__bzAvgObs) {
          t.__bzAvgObs = new MutationObserver(function () {
            var w = document.createTreeWalker(t, NodeFilter.SHOW_TEXT, null);
            var nn;
            while ((nn = w.nextNode())) {
              if (!nn.data.trim()) continue;
              if (nn.data !== cfg.avg) nn.data = cfg.avg;
              break;
            }
          });
          t.__bzAvgObs.observe(t, { childList: true, characterData: true, subtree: true });
        }
      });
      var rating = parseFloat(cfg.avg);
      if (!isNaN(rating)) {
        // update aria-label parent + set width Positive fill từng star
        document.querySelectorAll('.AirReviews-Blocks--Rate .AirReviews-StarRate').forEach(function (starRate) {
          var lbl = starRate.getAttribute('aria-label') || '';
          var newLbl = rating + ' out of 5 stars';
          if (lbl !== newLbl) starRate.setAttribute('aria-label', newLbl);
          var wrappers = starRate.querySelectorAll('.AirReviews-StarRate__Wrapper');
          if (wrappers.length === 5) {
            wrappers.forEach(function (w, i) {
              var pos = w.querySelector('.AirReviews-StarRate--Positive, .AirReviews-StarRate__Icon--Positive');
              if (!pos) return;
              var pct = Math.max(0, Math.min(1, rating - i)) * 100;
              pos.style.setProperty('width', pct + '%', 'important');
            });
          } else {
            // single composite Positive
            var pos1 = starRate.querySelector('.AirReviews-StarRate--Positive, .AirReviews-StarRate__Icon--Positive');
            if (pos1) pos1.style.setProperty('width', (rating / 5 * 100) + '%', 'important');
          }
        });
      }
    }
    // Per-star breakdown counts + progress bar width scale
    if (cfg.stars) {
      var starNums = {};
      var starTotal = 0;
      ['5', '4', '3', '2', '1'].forEach(function (k) {
        var v = parseInt(String(cfg.stars[k] || '').replace(/[^\d]/g, ''), 10);
        if (isNaN(v)) v = 0;
        starNums[k] = v;
        starTotal += v;
      });
      document.querySelectorAll('.AirReviews-Blocks--List .AirReviews-Blocks--ListItem--Clickable').forEach(function (row) {
        var m = (row.getAttribute('aria-label') || '').match(/^(\d)\s*star/i);
        if (!m) return;
        var star = m[1];
        var val = cfg.stars[star];
        if (val != null && val !== '') {
          var cnt = row.querySelector('.AirReviews-Blocks-Count');
          if (cnt) {
            var node = cnt.firstChild;
            if (node && node.nodeType === 3 && node.data !== String(val)) node.data = String(val);
          }
        }
        // Progress bar width = star[N] / total * 100%
        if (starTotal > 0) {
          var bar = row.querySelector('.AirReviews-Blocks-ProcessBar');
          if (bar) {
            var pct = Math.round(starNums[star] / starTotal * 100);
            var desired = pct + '%';
            if (bar.style.width !== desired) bar.style.setProperty('width', desired, 'important');
          }
        }
      });
    }
  }

  // Gate DOM-move ops (bzResortReviews, ensureCollapsedReviews) tới khi review list
  // "settled" — count không đổi trong 400ms VÀ không có loader. Nếu chạy khi app
  // đang React-mount cards, appendChild(card) làm React unmount -> reviews mất trắng
  // ngẫu nhiên sau F5.
  var _lastCardCount = -1;
  var _lastCountChangeAt = 0;
  function isReviewListSettled() {
    var listRv = document.querySelector('.AirReviews-Blocks__ListReview');
    if (!listRv) return false;
    var loader = document.querySelector('.AirReviews-Blocks__ListReview--Loader');
    if (loader) return false;
    var cards = listRv.querySelectorAll(':scope > .AirReviews-Blocks__ReviewDetails').length;
    var now = Date.now();
    if (cards !== _lastCardCount) {
      _lastCardCount = cards;
      _lastCountChangeAt = now;
      return false;
    }
    return cards > 0 && (now - _lastCountChangeAt) >= 400;
  }
  function applyTweaks() {
    shorten();
    relabelVerified();
    relabelTitle();
    relabelThankYou();
    ensureReviewCta();
    ensureShowLabel();
    relabelMediaSort();
    ensureDesktopStars();
    watchReviewList();
    ensureFiltersButton();
    overrideReviewCounts();
    ensureRecommend();
    relativizeDates();
    markDisabledStarRows();
    // Risky ops — chỉ khi settled (count không đổi ≥400ms, không loader)
    if (isReviewListSettled()) {
      bzResortReviews();
      ensureCollapsedReviews();
    } else {
      // Retry chain: 500ms, 1200ms — bắt state settled sau khi mutation dừng
      clearTimeout(_riskyRetry);
      _riskyRetry = setTimeout(function () {
        if (isReviewListSettled()) {
          bzResortReviews();
          ensureCollapsedReviews();
        } else {
          _riskyRetry = setTimeout(function () {
            if (isReviewListSettled()) {
              bzResortReviews();
              ensureCollapsedReviews();
            }
          }, 700);
        }
      }, 500);
    }
  }
  var _riskyRetry = null;

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyTweaks(); });
  }

  // Click dòng Rating breakdown đang active lần nữa -> KHÔNG cho app toggle tắt
  // filter (giữ nguyên filter). Chỉ nút "Clear filter" mới xoá. Dùng capture-phase
  // để chặn trước handler của app. Đồng thời chặn 1/2/3 sao qua pointerdown+mousedown+click.
  function isLowStarRow(row) {
    if (!row) return false;
    var m = (row.getAttribute('aria-label') || '').match(/^(\d)\s*star/i);
    return !!(m && +m[1] <= 3);
  }
  ['pointerdown', 'mousedown', 'click', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var row = e.target.closest && e.target.closest('.AirReviews-Blocks--ListItem--Clickable');
      if (row && isLowStarRow(row)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
  });
  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('.AirReviews-Blocks--ListItem--Clickable');
    if (row && row.classList.contains('AirReviews-Blocks--ListItem--Active')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  // Đánh dấu 1/2/3 sao rows là disabled (cursor + opacity qua CSS).
  function markDisabledStarRows() {
    document.querySelectorAll('.AirReviews-Blocks--ListItem--Clickable').forEach(function (row) {
      var m = (row.getAttribute('aria-label') || '').match(/^(\d)\s*star/i);
      if (m && +m[1] <= 3) row.classList.add('bz-star-row-disabled');
    });
  }

  // Hiện loading overlay khi đổi filter sao (click hàng breakdown bar). Chỉ khi có
  // thay đổi thực sự -> bỏ qua nếu bấm lại chính filter đang active. Capture-phase.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.AirReviews-Blocks--ListItem--Clickable');
    if (!trigger) return;
    if (trigger.classList.contains('AirReviews-Blocks--ListItem--Active')) return; // đang active -> không reload
    showReviewLoading();
  }, true);

  // Click nút "Filters" -> mở bottom-sheet (delegated để sống qua re-render).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.bz-filters-btn')) {
      e.preventDefault();
      openFilterSheet();
    }
  }, false);

  // Click "Show all reviews" -> bỏ collapse, hiện đủ review + pagination (delegated).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.bz-show-all')) {
      e.preventDefault();
      bzShowAll = true;
      ensureCollapsedReviews();
    }
  }, false);

  // Click phân trang (‹ › + số trang, cả 2 biến thể pagination của app) -> cuộn
  // lên đầu section review. Cuộn 2 nhịp: (1) ngay lúc click để không rơi xuống
  // footer khi app xoá list (anchor = #AirReviews-BlockWrapper, node ổn định,
  // KHÔNG dùng ListReview vì app thay node đó thành --Loader -> scrollIntoView
  // trên node detached = không cuộn); (2) khi app load xong trang mới, cuộn lại
  // trong watchReviewList vì chiều cao list đổi làm vị trí (1) bị trôi.
  function bzReviewsAnchor() {
    return document.getElementById('AirReviews-BlockWrapper')
        || document.querySelector('.AirReviews-Blocks__List');
  }
  document.addEventListener('click', function (e) {
    var pgBtn = e.target.closest && e.target.closest(
      '.AirReviews-Pagination__button, .AirReviews-Blocks__pagination .AirReviews-Navigation__Button, .AirReviews-Pagination__label'
    );
    if (!pgBtn || pgBtn.classList.contains('AirReviews-Pagination__button--disabled')) return;
    var target = bzReviewsAnchor();
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    bzScrollAfterPage = true;
  }, false);

  // Rate square hover: preview tô vàng tới ô đang hover; rời nhóm -> tô lại đủ 5.
  document.addEventListener('mouseover', function (e) {
    var lbl = e.target.closest && e.target.closest('.AirReviews-Blocks__ActionRate .AirReviews-StarRadio__Label');
    if (!lbl) return;
    var group = lbl.closest('.AirReviews-Blocks__ActionRate');
    var labels = [].slice.call(group.querySelectorAll('.AirReviews-StarRadio__Label'));
    paintStars(labels.indexOf(lbl) + 1);
  });
  document.addEventListener('mouseout', function (e) {
    var lbl = e.target.closest && e.target.closest('.AirReviews-Blocks__ActionRate .AirReviews-StarRadio__Label');
    if (!lbl) return;
    var group = lbl.closest('.AirReviews-Blocks__ActionRate');
    if (group && e.relatedTarget && group.contains(e.relatedTarget)) return; // vẫn trong nhóm
    paintStars(0); // về mặc định: không tô (nền trắng)
  });

  // Click .bz-product__reviews -> cuộn mượt xuống section review. Widget do app
  // inject LAZY (chỉ render khi section vào gần viewport) nên lúc mới load trang
  // section còn rỗng/thấp -> trang chưa đủ cao, cú cuộn đầu bị hụt, dừng ở
  // section phía trên. Fix: cuộn xong theo dõi widget render (tối đa ~4s) rồi
  // re-scroll đúng vị trí; user tự cuộn tiếp (wheel/touch) thì huỷ ngay.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.bz-product__reviews');
    if (!trigger) return;
    var target = document.querySelector('.shopify-section:has(#AirReviews-BlockWrapper)')
              || document.getElementById('shopify-section-template--27111241580819__1784868918b03df9f7');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var wrap = document.getElementById('AirReviews-BlockWrapper');
      var ready = wrap && wrap.offsetHeight > 200; // widget đã render nội dung thật
      if (ready || tries > 20) {
        cancel();
        if (ready) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
    function cancel() {
      clearInterval(iv);
      window.removeEventListener('wheel', cancel);
      window.removeEventListener('touchstart', cancel);
    }
    window.addEventListener('wheel', cancel, { passive: true });
    window.addEventListener('touchstart', cancel, { passive: true });
  }, false);

  function boot() {
    applyTweaks();
    // App inject widget async + re-render/đổi số sao (characterData) khi lọc -> theo dõi.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// v=1788837671

// v=1788838510

// v=1788841821

// v=1788841884
